import { connect } from 'react-redux'
import {
  getPaymentConfirmation,
  confirmPaymentConfirmation,
} from 'reduxpath/ducks/Project/PaymentConfirmation'

import List from './units'

function mapStateToProps(state) {
  return {
    invoiceList: state.ProjectPaymentConfirmation.invoices.rows,
    data: state.ProjectPaymentConfirmation.data,
    isLoading: state.ProjectPaymentConfirmation.isLoading,
  }
}

const mapDispatchToProps = dispatch => ({
  handlePageChange(key) {
    const limit = 10
    const qs = {
      sort: 'createdAt ASC',
      limit,
      skip: key.selected * limit,
    }
    dispatch(getPaymentConfirmation(qs))
  },

  handleConfirm(id) {
    return (e) => {
      e.preventDefault()
      dispatch(confirmPaymentConfirmation(id, () => {
        const limit = 10
        const qs = {
          sort: 'createdAt ASC',
          limit,
          skip: 0,
        }
        dispatch(getPaymentConfirmation(qs))
      }))
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(List)
